import React from 'react'
import Navbar from '../Navbar'
import Hero from './Hero'
import "./index.scss"
const Home = () => {
  return (
    <div className="home">
        <Navbar/>
        <Hero/>

  
    </div>
  )
}

export default Home